export const SIGNUP_SUCCESS = "SIGN_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ADD_POST = "ADD_POST";
export const GET_POST = "GET_POST";
export const DELETE_POST = "DELETE_POST";
export const GET_COMMENTS = "GET_COMMENTS";
export const ADD_COMMENT = "ADD_COMMENT";
export const COMMENT_FAIL = "COMMENT_FAIL";
export const GET_UPDATE = "GET_UPDATE";
export const POST_UPDATED = "POST_UPDATED"; 
export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const GET_ERRORS = "GET_ERRORS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const ADD_PROFILE = "ADD_PROFILE";
export const RESET_PASSWORD = "RESET_PASSWORD";